
<template>
  <div></div>
</template>

<script>
import LDraw from "leaflet-draw";
import "leaflet-easybutton";
import "../../node_modules/leaflet-easybutton/src/easy-button.css";

export default {
  name: "DrawComponent",
  components: {},
  props: {
    current_map_object: { required: true },
    draw_mode: { type: Boolean, required: true },
    key_file_current: {required: true },
  },
  event: "change",

  data() {
    return {
      draw_control: null,
      current_shape: null,
      current_easy_button: null,
    };
  },
  methods: {
    trigger_send_shape() {

      if (this.current_shape) {
        let cords_obj = this.current_shape.getLatLngs()[0];

        //  trigger a upload de ruta
        let url = "./upload_shape_json";
        let data_for_shape = {lat_lon_list: cords_obj }

        this.axios.post(url, data_for_shape, {}).then((response) => {


          // entregar filekey
          this.$emit("update:key_file_current", response.data["key"]);

          // esto realizara de forma automatica el clean. Ya que draw_mode=False hace clean
          this.$emit("update:draw_mode", false); // esto
        });
      }
    },

    clean() {
      let map = this.current_map_object;
      map.removeControl(this.draw_control);
      if (this.current_shape) {
        this.current_shape.remove();
      }
      this.current_easy_button.removeFrom(map);
    },

    add_draw_tools() {
      let map = this.current_map_object;
      if (map) {
        console.log(LDraw); // No quitar ?? (Carga libreria leafletjs draw)

        var drawnItems = new window.L.FeatureGroup();
        map.addLayer(drawnItems);

        const drawControl = new window.L.Control.Draw({
          position: "topright",
          draw: {
            polyline: false,
            polygon: true,
            rectangle: true,
            circle: false,
            marker: false,
            circlemarker: false,
          },
          edit: {
            featureGroup: drawnItems,
          },
        });
        map.addControl(drawControl);

        this.draw_control = drawControl;

        this.current_easy_button = window.L.easyButton({
          position: "topright",
          leafletClasses: true,
          states: [
            {
              stateName: "center",
              onClick: () => {
                this.trigger_send_shape();
              },
              icon: "<span>OK</span>",
            },
          ],
        });
        this.current_easy_button.addTo(map);


        map.on(window.L.Draw.Event.CREATED, (e) => {
          if (this.current_shape) {
            this.current_shape.remove();
          }
          const layer = e.layer;
          // Do whatever else you need to. (save to db, add to map etc)
          drawnItems.addLayer(layer);
          this.current_shape = layer;
          this.trigger_send_shape()
        });

        map.on(window.L.Draw.Event.DELETED, () => {
          this.current_shape = null;
        });
      }
    },
  },
  watch: {
    draw_mode: function (newVal) {
      // watch it
      let map = this.current_map_object;

      if (map) {
        if (newVal) {
          this.add_draw_tools();
        } else {
          this.clean();
        }
      }
    },
  },
};
</script>


<style scoped>
</style>
